module.exports = __webpack_public_path__ + "img/red-warning.17417489.svg";